import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, of } from 'rxjs';
import { catchError, tap, switchMap } from 'rxjs/operators';
import { EmployeesModel } from 'src/app/model/employees.model';
import { CatalogModel } from 'src/app/model/other-catalogs-models';
import { EmployeesService } from 'src/app/services/employees.service';
import { CatEmployeeJobService } from 'src/app/services/cat-employee-job.service';
import { CreatorService } from 'src/app/services/creator.service';
import { ModalNewEmployeeComponent } from 'src/app/shared/modal-new-employee/modal-new-employee.component';
import { extractUploadErrorMessages } from 'src/app/utils/upload-error.util';
import { downloadBlobFile } from 'src/app/utils/download-file.util';

@Component({
  selector: 'app-cat-employees',
  templateUrl: './cat-employees.component.html',
  styleUrls: ['./cat-employees.component.css']
})
export class CatEmployeesComponent implements OnInit {
  // estado pagina
  public viewStatus = 0;  // -1:nada, 0:spinner, 1:tabla
  public employees: EmployeesModel[] = [];
  public employeeJobCatalog: CatalogModel[] = [];

  // carga de excel
  @ViewChild('fileInput', { static: false }) fileInputRef: ElementRef;
  public uploadFile: File = null;
  public replaceAll = false;

  // opciones datatables
  dtOptions = {
    order: [],
    responsive: true,
    columnDefs: [
      { responsivePriority: 1, width: 100, targets: -1 }
    ],
    bLengthChange: true,
    searching: true,
    dom: '<"row"<"col"l><"col"<"text-center"B>><"col"f>><"row"<"col"t>><"row"<"col"i><"col"p>>',
    buttons: ['csv', 'excel'],
    autoWidth: false,
    paging: true,
    pageLength: 100,
    language: {
      processing: 'Procesando...',
      search: 'Buscar:',
      lengthMenu: 'Mostrar _MENU_ elementos',
      info: 'Mostrando del _START_ al _END_ de _TOTAL_ elementos',
      infoEmpty: 'Mostrando ningún elemento.',
      infoFiltered: '(filtrado _MAX_ elementos total)',
      infoPostFix: '',
      loadingRecords: 'Cargando registros...',
      zeroRecords: 'No se encontraron registros',
      emptyTable: 'No hay datos disponibles en la tabla',
      paginate: {
        first: 'Primero',
        previous: 'Anterior',
        next: 'Siguiente',
        last: 'Último'
      },
      aria: {
        sortAscending: ': Activar para ordenar la tabla en orden ascendente',
        sortDescending: ': Activar para ordenar la tabla en orden descendente'
      },
      buttons: [
        'excel'
      ]
    }
  };

  /////////////////
  constructor(
    private creator: CreatorService,
    private modalService: NgbModal,
    private employeesService: EmployeesService,
    private catEmployeeJobService: CatEmployeeJobService,
    private toastr: ToastrService
  ) { }
  ngOnInit() {
    this.getCatalogs();
  }

  //
  add = () => {
    let employee = this.creator.newEmployee();
    let modalRef = this.modalService.open(ModalNewEmployeeComponent, { centered: true, backdrop: 'static', keyboard: false, windowClass: 'dark-modal', size: 'lg' });
    modalRef.componentInstance.employee = { ...employee };
    modalRef.componentInstance.mode = 'create';
    modalRef.result.then(
      data => console.log(data),
      reason => {
        console.log(reason);
        this.viewStatus = 0;
        this.getCatalogs();
      }
    );
  }
  edit = (employee: EmployeesModel) => {
    let modalRef = this.modalService.open(ModalNewEmployeeComponent, { centered: true, backdrop: 'static', keyboard: false, windowClass: 'dark-modal', size: 'lg' });
    modalRef.componentInstance.employee = { ...employee };
    modalRef.componentInstance.mode = 'edit';
    modalRef.result.then(
      data => console.log(data),
      reason => {
        console.log(reason);
        this.viewStatus = 0;
        this.getCatalogs();
      }
    );
  }

  // EXCEL
  onFileSelected = (event: any) => {
    this.uploadFile = event.target.files.length > 0 ? event.target.files[0] : null;
  }
  uploadExcel = () => {
    if (!this.uploadFile) {
      this.toastr.warning('Selecciona un archivo Excel primero.');
      return;
    }
    let userName = localStorage.getItem('com_userName');
    this.viewStatus = 0;

    // Refrescar catálogo de puestos antes de cargar
    this.catEmployeeJobService.catalog()
      .pipe(
        tap((jobResp: any) => {
          this.employeeJobCatalog = jobResp.data;
        }),
        switchMap(() =>
          this.employeesService.upload(userName, this.uploadFile, this.replaceAll)
        ),
        tap((resp: any) => {
          if (resp && resp.codeHttpStatus === 200) {
            this.toastr.success('El catálogo se cargó correctamente.');
            this.resetFileInput();
            this.getCatalogs();
          } else {
            this.viewStatus = 1;
            const messages = extractUploadErrorMessages(resp);
            this.toastr.error(messages.join('<br>'), '¡Atención!', { enableHtml: true });
          }
        }),
        catchError((error: HttpErrorResponse) => {
          this.viewStatus = 1;
          const messages = extractUploadErrorMessages(error);
          this.toastr.error(messages.join('<br>'), '¡Atención!', { enableHtml: true });
          return of(null);
        })
      )
      .subscribe();
  }
  resetFileInput = () => {
    this.uploadFile = null;
    if (this.fileInputRef) this.fileInputRef.nativeElement.value = '';
  }
  downloadLayout = () => {
    this.employeesService.downloadLayout().subscribe(
      (data: Blob) => downloadBlobFile(data, 'layout_empleados.xlsx'),
      () => this.toastr.error('No se pudo descargar el layout.')
    );
  }

  // INFO
  jobDescription = (employeeJobId: number) => {
    let job = this.employeeJobCatalog.find(j => j.id === employeeJobId);
    return job ? job.description : '';
  }
  getCatalogs = () => {
    forkJoin(
      this.employeesService.getAll(),
      this.catEmployeeJobService.catalog()
    )
      .pipe(
        tap(([empResp, jobResp]: [any, any]) => {
          this.employeeJobCatalog = jobResp.data;
          this.employees = empResp.data;
          this.viewStatus = 1;
        }),
        catchError(error => {
          this.viewStatus = -1;
          return of(this.toastr.error('Ocurrió un error al leer el catálogo de empleados.'));
        })
      )
      .subscribe();
  }
}
